/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import TButton from './button.mjs';
import withInstall from '../utils/withInstall.mjs';
import './style/css.mjs';
import './type.mjs';
import '../_chunks/dep-35b16530.mjs';
import '../_chunks/dep-d531a7f4.mjs';
import '../_chunks/dep-6e49aa22.mjs';
import '../_chunks/dep-6da93342.mjs';
import 'vue';
import '../loading/index.mjs';
import '../loading/directive.mjs';
import 'lodash-es';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../_chunks/dep-8d3c9348.mjs';
import '../loading/icon/gradient.mjs';
import '../hooks/useConfig.mjs';
import '../config-provider/hooks/useConfig.mjs';
import '../config-provider/utils/context.mjs';
import '../_chunks/dep-99da72b8.mjs';
import '../_chunks/dep-b0ea6825.mjs';
import '../_chunks/dep-2705c570.mjs';
import '../_chunks/dep-bc824998.mjs';
import '../config-provider/type.mjs';
import '../_chunks/dep-b0b0fb5e.mjs';
import '../_chunks/dep-684f6096.mjs';
import '../_chunks/dep-11896cb9.mjs';
import '../utils/dom.mjs';
import '../_chunks/dep-5112e56c.mjs';
import '../utils/render-tnode.mjs';
import '../hooks/useTeleport.mjs';
import '../loading/props.mjs';
import '../loading/type.mjs';
import './props.mjs';
import '../hooks/useRipple.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../hooks/useDisabled.mjs';

var Button = withInstall(TButton);

export { Button, Button as default };
//# sourceMappingURL=index.mjs.map
